import { Routes } from '@angular/router';
import { NotFoundComponent } from '../components/not-found/not-found.component';
import { UnauthorizedComponent } from '../components/unauthorized/unauthorized.component';
import { OnboardingContainerComponent } from '../modules/onboarding/onboarding-container.component';

export const ROUTE_DEFINITIONS: Routes = [
    {
        path: 'auth',
        loadChildren: () => import('../modules/onboarding/router/onboarding-router.constants').then((m) => m.ONBOARDING_ROUTE_DEFINITIONS)
    },
    {
        path: 'authorize-device',
        loadChildren: () => import('../modules/device-code/router/device-router.constants').then((m) => m.DEVICE_ROUTE_DEFINITIONS)
    },
    {
        path: 'oauth/authorize',
        loadChildren: () => import('../modules/oauth-authorize/router/oauth-authorize-router.constants').then((m) => m.OAUTH_AUTHORIZE_ROUTE_DEFINITIONS)
    },
    {
        path: 'delivery',
        loadChildren: () => import('../modules/portal/router/portal-router.constants').then((m) => m.DELIVERY_ROUTE_DEFINITIONS)
    },
    {
        path: 'download',
        loadChildren: () => import('../modules/portal/router/portal-router.constants').then((m) => m.DOWNLOAD_ROUTE_DEFINITIONS)
    },
    {
        path: '',
        loadChildren: () => import('../modules/relayter/router/relayter-router.constants').then((m) => m.RELAYTER_ROUTE_DEFINITIONS)
    },
    {
        path: 'unauthorized',
        component: OnboardingContainerComponent,
        children: [
            {
                path: '',
                component: UnauthorizedComponent
            }
        ]
    },
    {
        path: '**',
        component: OnboardingContainerComponent,
        children: [
            {
                path: '',
                component: NotFoundComponent
            }
        ]
    }
];
